import React, { useEffect, useCallback, useState } from 'react';
import Nav from "../components/Nav";
import BlockHeading from "../components/BlockHeading";
import { useForm } from "react-hook-form";
import Footer from "../components/Footer";
import Header from "../components/Header";
import RadioButtonComponent from '../components/RadioButtonComponent';
import BottomNavBar from '../components/BottomNavBar';
import SATextArea from '../components/SATextArea';
import SATextInput from '../components/SATextInput';
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import DateComponent from '../components/DateComponents';
import * as counselorInfoAPI from "../services/counselor";
import moment from 'moment';
import * as yourInfoAPI from "../services/yourInfoServices";
import toast, { toastConfig } from 'react-simple-toasts';
import { Spinner } from 'react-bootstrap';

const Counselor = () => {
    const navigate = useNavigate();
    const location = useLocation();
    let [searchParams] = useSearchParams();

    const [loader, setLoader] = useState(false)
    const [studHCode, setHexCode] = useState('');
    const [appFirstName, setAppFirstName] = useState('');
    const [appLastName, setAppLastName] = useState('');
    const [appEmail, setAppEmail] = useState('');

    toastConfig({
        render: message => <div style={{ backgroundColor: '#cc2427', color: 'white', padding: 10, borderRadius: 10, fontSize: 18, fontWeight: '700' }}>{message}</div>,
    })

    // let hexCode = ""; 

    useEffect(() => {
        document.title = 'Counselor Application | Families of WWII Vetearnas';
        window.scrollTo({ top: 0, behaviour: "smooth" })
    }, []);

    useEffect(() => {
        let hexCode = location?.state?.hexCode ? location.state.hexCode : "";
        if (hexCode === "") {
            hexCode = searchParams.get("code")
        }
        setHexCode(hexCode);
        
    }, [location?.state?.hexCode,searchParams]);

    const { register, handleSubmit, control, formState: { errors }, reset } = useForm({
        defaultValues: {
            leaderShip: "0",
            perseveranceUnderStress: "0",
            reliability: "0",
            cooperativeness: "0",
            oralCommunication: "0",
            writtenCommunication: "0",
            interpersonalRegard: "0",
            valueOrientation: "0",
            flexibility: "0",
            ethics: "0",
            problemSolving: "0",
            globalAssessment: "0",
            comments: "",
            filledByFirstName: "",
            filledByLastName: "",
            filledByTitle: "",
            studentKnown: "",
            date: "",
            emailAddress: ""
        }

    })

    const getCounselorApi = useCallback(async () => {
        setLoader(true)
        try {
            await yourInfoAPI.getStudentInformation(`${studHCode}/your-info`).then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    let studentInfoData = res.data;
                    setAppEmail(studentInfoData.emailAddress);
                    setAppFirstName(studentInfoData.firstName && studentInfoData.firstName.trim())
                    setAppLastName(studentInfoData.lastName && studentInfoData.lastName.trim())
                } else {
                    if (res.status === 204) {
                        return
                    }
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            return error
        }
        try {
            await counselorInfoAPI.getCouselorReviewInfo(`${studHCode}/counselor/Review`).then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    let counselorInfoData = res.data;
                    reset({
                        leaderShip: counselorInfoData.leaderShip,
                        perseveranceUnderStress: counselorInfoData.perseveranceUnderStress,
                        reliability: counselorInfoData.reliability,
                        cooperativeness: counselorInfoData.cooperativeness,
                        oralCommunication: counselorInfoData.oralCommunication,
                        writtenCommunication: counselorInfoData.writtenCommunication,
                        interpersonalRegard: counselorInfoData.interpersonalRegard,
                        valueOrientation: counselorInfoData.valueOrientation,
                        flexibility: counselorInfoData.flexibility,
                        ethics: counselorInfoData.ethics,
                        problemSolving: counselorInfoData.problemSolving,
                        globalAssessment: counselorInfoData.globalAssessment,
                        comments: counselorInfoData.comments,
                        filledByFirstName: counselorInfoData.filledByFirstName,
                        filledByLastName: counselorInfoData.filledByLastName,
                        filledByTitle: counselorInfoData.filledByTitle,
                        studentKnown: counselorInfoData.studentKnownFrom,
                        date: moment(counselorInfoData.filledByDate).format('MM/DD/YYYY'),
                        emailAddress: counselorInfoData.counselorEmail
                    })
                } else {
                    if (res.status === 204) {
                        return
                    }
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            return error
        }
    }, [studHCode,reset]);

    useEffect(() => {
        if(studHCode){
            getCounselorApi()
        }
    }, [studHCode,getCounselorApi]);

    const onSubmit = async (data) => {
       

        let counselorReview = {
            "studentFirstName": appFirstName,
            "studentLastName": appLastName,
            "studentEmail": appEmail,
            "leaderShip": data.leaderShip,
            "perseveranceUnderStress": data.perseveranceUnderStress,
            "reliability": data.reliability,
            "cooperativeness": data.cooperativeness,
            "oralCommunication": data.oralCommunication,
            "writtenCommunication": data.writtenCommunication,
            "interpersonalRegard": data.interpersonalRegard,
            "valueOrientation": data.valueOrientation,
            "flexibility": data.flexibility,
            "ethics": data.ethics,
            "problemSolving": data.problemSolving,
            "globalAssessment": data.globalAssessment,
            "comments": data.comments,
            "filledByFirstName": data.filledByFirstName,
            "filledByLastName": data.filledByLastName,
            "filledByTitle": data.filledByTitle,
            "filledByDate": moment(data.date).format('YYYY-MM-DD'),
            "studentKnownFrom": data.studentKnown,
            "counselorEmail": data.emailAddress
        }
        setLoader(true)
        try {
            await counselorInfoAPI.postCouselorRatingInfo(counselorReview
                , `${studHCode}/counselor`).then((res) => {
                    setLoader(false)
                    if (res.status === 200) {
                        navigate("/counselor-review", {
                            state: { hexCode: studHCode }
                        })
                    } else if (res.status === 422) {
                        let errorData = res?.data?.errors
                        if (Object.keys(errorData) && Object.keys(errorData).length > 0) {
                            Object.keys(errorData).forEach((err, index) => {
                                toast(errorData[err][0], { position: 'top-right', backgroundColor: 'red' })
                            })
                        }
                    } else {
                        toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    }
                })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
        }
    }

    const handleNavBack = (to) => {
        // navigate(to,{
        //     state:{hexCode : studHCode}
        // })
    }

    return (
        <section >
            <Header title="Counselor/Academic Advisor Application" />
            {loader && <div lg={12} md={12} sm={12} className="loaderContainer">
                <Spinner animation="border" variant="primary" /> </div>}
            <div className="container py-3 py-md-4 py-md-5">
                <div className="row">
                    <div className="col-12">
                        <Nav navbType="counselor" handleNavBack={handleNavBack} />
                        <BlockHeading title="This form must be completed by your high school or college academic counselor." />
                        <p className="lead">Please fill out the form below, with 5 being always exhibits
                            these characteristics, and 1 being never.</p>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <label htmlFor="AppFirstName">Applicant First Name:<strong className="text-primary">*</strong></label>
                                        <input type="text" name="AppFirstName" id="AppFirstName" className="form-control"
                                            placeholder="Applicant First Name" disabled value={appFirstName} />
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <label htmlFor="AppLastName">Applicant Last Name:<strong className="text-primary">*</strong></label>
                                        <input type="text" name="AppLastName" id="AppLastName" className="form-control"
                                            placeholder="Applicant Last Name" disabled value={appLastName} />
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <label htmlFor="AppEmail">Applicant Email:<strong className="text-primary">*</strong></label>
                                        <input type="email" name="AppEmail" id="AppEmail" className="form-control"
                                            placeholder="Applicant Email" disabled value={appEmail} />
                                    </div>
                                </div>

                            </div>

                            <hr />

                            <div className="row">
                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Leadership"}
                                        register={register}
                                        errors={errors}
                                        name={'leaderShip'}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Perseverance Under Stress"}
                                        register={register}
                                        errors={errors}
                                        name={'perseveranceUnderStress'}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Reliability"}
                                        register={register}
                                        errors={errors}
                                        name={'reliability'}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Cooperativeness"}
                                        register={register}
                                        errors={errors}
                                        name={'cooperativeness'}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Oral Communication"}
                                        register={register}
                                        errors={errors}
                                        name={'oralCommunication'}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Written Communication"}
                                        register={register}
                                        errors={errors}
                                        name={'writtenCommunication'}
                                    />
                                </div>
                            </div>

                            <div className="row">

                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Interpersonal Regard"}
                                        register={register}
                                        errors={errors}
                                        name={'interpersonalRegard'}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Value Orientation"}
                                        register={register}
                                        errors={errors}
                                        name={'valueOrientation'}
                                    />
                                </div>
                            </div>

                            <div className="row">

                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Flexibility"}
                                        register={register}
                                        errors={errors}
                                        name={'flexibility'}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Ethics"}
                                        register={register}
                                        errors={errors}
                                        name={'ethics'}
                                    />
                                </div>
                            </div>

                            <div className="row">

                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Problem Solving"}
                                        register={register}
                                        errors={errors}
                                        name={'problemSolving'}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <RadioButtonComponent
                                        title={"Global Assessmenthics"}
                                        register={register}
                                        errors={errors}
                                        name={'globalAssessment'}
                                    />
                                </div>
                            </div>



                            <hr />

                            <div className="row">
                                <div className="col-lg-12">
                                    <SATextArea
                                        register={register}
                                        htmlFor={"comments"}
                                        name={"comments"}
                                        label={"Comments:"}
                                        isStrong={true}
                                        requiredObj={{ required: "Comments is required!", maxLength: { value: 400, message: "Max length is 400 characters!" } }}
                                        placeholder={"Please provide examples illustrating any of the above characteristics or privde additional characteristics that make this applicant a strong candidate for the Families of WWII Veterans Scholarship. (required)"}
                                        maxLength={400}
                                        id={"commentsHelp"}
                                        errMsg={errors.comments?.message}
                                    />
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-lg-6">
                                    <SATextInput
                                        register={register}
                                        htmlFor={"filledByFirstName"}
                                        name={"filledByFirstName"}
                                        label={"Filled by First Name:"}
                                        isStrong={true}
                                        requiredText={"Filled by First Name is required!"}
                                        type={"text"}
                                        placeholder={"Filled by First Name (required)"}
                                        errors={errors}
                                        maxLength={32}
                                        id={"filledFirstNameHelp"}
                                        errMsg={errors.filledByFirstName?.message}
                                        requiredObj={{
                                            required: "Filled by First Name is required!",
                                            pattern: {
                                                value: /[\sa-zA-Z'`~.s -]+$/, message: "Invalid field Filled by First Name!"
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <SATextInput
                                        register={register}
                                        htmlFor={"filledByLastName"}
                                        name={"filledByLastName"}
                                        label={"Filled by Last Name:"}
                                        isStrong={true}
                                        maxLength={32}
                                        requiredText={"Filled by Last Name is required!"}
                                        type={"text"}
                                        placeholder={"Filled by Last Name (required)"}
                                        errors={errors}
                                        id={"filledLastNameHelp"}
                                        errMsg={errors.filledByLastName?.message}
                                        requiredObj={{
                                            required: "Filled by Last Name is required!",
                                            pattern: {
                                                value: /[\sa-zA-Z'`~.s -]+$/, message: "Invalid field Filled by Last Name!"
                                            }
                                        }}
                                    />
                                </div>

                                <div className="col-lg-6">
                                    <SATextInput
                                        register={register}
                                        htmlFor={'htmlForEmailAddress'}
                                        name={'emailAddress'}
                                        label={"Email:"}
                                        isStrong={true}
                                        type={"text"}
                                        placeholder={"Email Address (required)"}
                                        errors={errors}
                                        id={'emailAddress'}
                                        maxLength={64}
                                        errMsg={errors.emailAddress?.message}
                                        requiredObj={{
                                            required: "Email Address is required!"
                                            , pattern: {
                                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,25}$/
                                                , message: "Invalid Email Address!"
                                            }
                                        }
                                        }
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <SATextInput
                                        register={register}
                                        htmlFor={"filledByTitle"}
                                        name={"filledByTitle"}
                                        label={"Filled by Title:"}
                                        isStrong={true}
                                        requiredText={"Filled by Title is required!"}
                                        type={"text"}
                                        placeholder={"Filled by Title (required)"}
                                        errors={errors}
                                        id={"filledTitleHelp"}
                                        maxLength={32}
                                        errMsg={errors.filledByTitle?.message}
                                        requiredObj={{
                                            required: "Filled by Title is required!",
                                            pattern: {
                                                value: /[\sa-zA-Z'`~.s -]+$/, message: "Invalid field Filled by Title!"
                                            }
                                        }}

                                    />
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">

                                        <DateComponent
                                            label={"Date:"}
                                            control={control}
                                            htmlFor={"date"}
                                            name={"date"}
                                            isStrong={true}
                                            required={"Date is required!"}
                                            invalidMessage={"Invalid Date!"}
                                            placeholder={"Date: mm/dd/yyyy"}
                                            id={"dateHelp"}
                                            errMsg={errors.date?.message}
                                        />


                                    </div>
                                </div>

                                <div className="col-lg-6">

                                    <SATextInput
                                        register={register}
                                        htmlFor={"studentKnown"}
                                        name={"studentKnown"}
                                        label={"How long have you known this student?"}
                                        isStrong={true}
                                        requiredText={"How long have you known this student is required!"}
                                        type={"text"}
                                        placeholder={"How long have you known this student? (required)"}
                                        errors={errors}
                                        id={"studentKnownHelp"}
                                        maxLength={64}
                                        errMsg={errors.studentKnown?.message}
                                        requiredObj={{ required: "How long have you known this student is required!" }}
                                    />
                                </div>


                            </div>

                            <BottomNavBar
                                submitButtonTitle="REVIEW" />
                        </form >

                    </div>
                </div>
            </div>
            <Footer />
        </section>
    );
}

export default Counselor;